import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const gestaoCandidatosRoutes: Routes = [
  {
    path: 'gestao-candidatos',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Gestão de Candidatos',
      breadcrumb: [{ label: 'Gestão de Candidatos', url: '/gestao-candidatos' }],
    },
    children: [
      {
        path: 'distribuicao',
        loadComponent: () =>
          import('./distribuicao-candidatos/distribuicao.component').then((m) => m.DistribuicaoComponent),
        data: {
          title: 'Distribuição de Candidatos',
          roles: [
            Role.DISTRIBUICAO_CONSULTAR,
            Role.DISTRIBUICAO_EDITAR,
            Role.DISTRIBUICAO_DISTRIBUIR_AUTOMATICO,
            Role.DISTRIBUICAO_DISTRIBUIR_MANUAL,
            Role.DISTRIBUICAO_LIMPAR,
            Role.DISTRIBUICAO_ATIVAR_TECNICO,
            Role.DISTRIBUICAO_DESATIVAR_TECNICO,
            Role.DISTRIBUICAO_RELATORIO
          ],
          breadcrumb: [
            { label: 'Distribuição de Candidatos', url: '/gestao-candidatos/distribuicao' },
          ],
        },
      },
      {
        path: 'demanda-judicial',
        loadComponent: () =>
          import('./demanda-judicial/demanda-judicial.component').then((m) => m.DemandaJudicialComponent),
        data: {
          title: 'Demanda Judicial de Análise Documental',
          roles: [Role.DISTRIBUICAO_CONSULTAR, Role.DISTRIBUICAO_EDITAR],
          breadcrumb: [
            { label: 'Demanda Judicial de Análise Documental', url: '/gestao-candidatos/demanda-judicial' },
          ],
        },
      },
    ],
  },
];
